<template>
  <div class="row custom-record">
    <div class="col-md-1">
      <input
        type="checkbox"
        v-model="isChecked"
        class="custom-checkbox"
        v-show="!recordData.isPrimary"
      />
    </div>
    <div class="col-md-2 custom-data">
      <span>{{ recordData.emailTypeName }}</span>
    </div>
    <div class="col-md-5 custom-data">
      <span>{{ recordData.emailAddress }}</span>
    </div>
    <div class="col-md-2">
      <span v-show="recordData.isPrimary">(primary)</span>
    </div>
    <div class="col-md-1">
      <a
        href="#"
        @click="editItem"
      >edit</a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'contact-email-record',
  props: {
    recordData: Object
  },
  computed: {
    isChecked: {
      get() {
        return this.recordData.isChecked
      },
      set(value) {
        this.$emit(
          'itemChecked',
          {
            contactEmail: this.recordData.contactEmail,
            contact: this.recordData.contact
          },
          value
        )
      }
    }
  },
  methods: {
    editItem() {
      this.$emit('editItem', this.recordData)
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-record {
  padding: 5px;
}
.custom-data {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/contacts/listings/contact-email-record.vue